import ProtectedRoute from "routes/ProtectedRoute";

export const newEventRoute = [
  {
    path: "events",

    // Lazy-load AdminLayout
    lazy: async () => {
      const mod = await import("components/UI/AdminLayout");
      const AdminLayout = mod.default;
      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        // Lazy-load EventsLayout
        lazy: async () => {
          const mod = await import("components/UI/EventsLayout");
          const EventsLayout = mod.default;
          return { Component: EventsLayout };
        },

        children: [
          {
            index: true,
            lazy: async () => {
              const mod = await import("views/Admin/Events");
              const Events = mod.default;
              return { Component: Events };
            },
          },
          {
            path: "details/:eventId",
            lazy: async () => {
              const mod = await import("views/Admin/Events/EventDetails");
              const EventDetails = mod.default;
              return { Component: EventDetails };
            },
          },
          {
            path: "event-review/:eventId/:presentationId",
            lazy: async () => {
              const mod = await import("views/Admin/Events/event-review-page");
              const EventReviewPage = mod.default;
              return { Component: EventReviewPage };
            },
          },
        ],
      },
    ],
  },
  {
    path: "manage-event",
    lazy: async () => {
      const mod = await import("views/Admin/Events/manage-event");
      const ManageEvent = mod.ManageEvent;

      return {
        Component: () => (
          <ProtectedRoute>
            <ManageEvent />
          </ProtectedRoute>
        ),
      };
    },
  },
];
